module.exports = __webpack_public_path__ + "img/growcify-manage-banner.9517debe.png";